import {DetailColumns, DetailPane, FormDialog} from '@management-ui/core';
import {Edit} from '@mui/icons-material';
import {reverse} from 'named-urls';
import React, {useState} from 'react';
import Text from '../../../../components/Text';
import routes from '../../../../routes';
import PackingListForm from '../../forms/PackingListForm';

const Customs = ({list, onListUpdated}) => {
  const [fields, setFields] = useState('customer');
  const [showForm, setShowForm] = useState(false);

  return (
    <>

      <DetailColumns columns={[

        <DetailPane
          title="Customer"
          actions={list.archived || list.locked ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('customer') || setShowForm(true)},
          ]}
          details={[
            {
              title: 'Customer',
              value: list.customer?.name ?? '-',
              route: list.customer ? reverse(routes.contacts.detail, {id: list.customer.id}) : null
            },
            {title: 'Customer Address', value: <Text text={list.customer_address ?? '-'}/>},
          ]}
        />,

        <DetailPane
          title="Customs Clearance"
          actions={list.archived || list.locked ? [] : [
            {title: 'Edit', icon: <Edit/>, onClick: () => setFields('customs') || setShowForm(true)},
          ]}
          details={[
            {title: 'Clearance Address', value: <Text text={list.customs_address ?? '-'}/>},
          ]}
        />,
      ]}/>

      <FormDialog
        title="Edit Packing List"
        open={showForm}
        onClose={() => setShowForm(false)}
        render={(props) => (
          <PackingListForm
            {...props}
            list={list}
            fields={fields}
            onSaved={(updated) => setShowForm(false) || onListUpdated(updated)}/>
        )}
      />

    </>
  );
}

export default Customs;
